export const ERROR_CODE_RANGES = {
    ACTIVITIES: {
        BASE: 200,
        LIST_ACTIVITIES: 201,
        CREATE_ACTIVITY: 202,
        UPDATE_ACTIVITY: 203,
        DELETE_ACTIVITY: 204,
        LIST_CUSTOM_ASSIGNMENTS: 205,
        CREATE_CUSTOM_ASSIGNMENT: 206,
        CLONE_CUSTOM_ASSIGNMENT: 207,
        ASSIGN_GRAPHIC_ORG_TO_EBOOK: 208,
        UPDATE_GRAPHIC_ORG_TO_EBOOK: 209,
        UPDATE_CUSTOM_ASSIGNMENT: 210,
        DELETE_CUSTOM_ASSIGNMENT: 211,
        UNSHARE_CUSTOM_ASSIGNMENT: 212,
        GET_ASSIGNMENT_STATUS: 213,
        UPDATE_SEQUENCE: 214,
        LIST_ACTIVITIES_BY_IDS: 215,
        LIST_RESOURCE_ACTIVITIES: 216,
        UNKNOWN: 299
    },
    BOOKS: {
        BASE: 300,
        LIST_ALL_BOOKS: 301,
        LIST_EBOOK_DATA: 302,
        CREATE_BOOK: 303,
        UPDATE_BOOK: 304,
        UPDATE_BOOK_BY_PAGE: 305,
        LIST_BOOK_ORDER: 306,
        UPDATE_BOOK_ORDER: 307,
        LIST_ACTIVE_INACTIVE_BOOKS: 308,
        LIST_ALLOWED_BOOKS: 309,
        UNKNOWN: 399
    },
    ORGANIZATIONS: {
        BASE: 600,
        CREATE_ORGANIZATION: 601,
        GET_ORGANIZATION: 602,
        UPDATE_ORGANIZATION: 603,
        DELETE_ORGANIZATION: 604,
        LIST_ORGANIZATIONS: 605,
        FETCH_SCHOOL_INFO: 606,
        UNKNOWN: 699
    },
    CHAT: {
        BASE: 800,
        GET_CHAT_USERS: 801,
        HANDLE_MESSAGE: 802,
        SEND_MESSAGE: 803,
        GET_MESSAGES: 804,
        GET_USER_CONFIG: 805,
        UPDATE_AVATAR: 806,
        UPDATE_CHAT_HOUR: 807,
        UPDATE_CHAT_SEEN: 808,
        UPDATE_CHAT_DISABLE: 809,
        UPDATE_NOTIFICATION: 810,
        CREATE_SCHEDULED_MESSAGE: 811,
        GET_SCHEDULED_MESSAGE: 812,
        REMOVE_SCHEDULED_MESSAGE: 813,
        UPDATE_SCHEDULED_MESSAGE: 814,
        UNKNOWN: 899
    },
    LOGS: {
        BASE: 900,
        CREATE_LOG: 901,
        LIST_LOGS: 902,
        ADD_INAPPROPRIATE_ALERT: 903,
        LIST_INAPPROPRIATE_ALERT: 904,
        LIST_LENGTH_INAPPROPRIATE_ALERT: 905,
        ARCHIVE_INAPPROPRIATE_ALERT: 906,
        GET_MORE_INFO_INAPPROPRIATE_ALERT: 907,
        UNKNOWN: 999
    },
    AUTH: {
        BASE: 700,
        LOGIN: 701,
        REDIRECT: 702,
        FETCH_USER_DATA: 703,
        LOGOUT: 704,
        USER_NOT_FOUND: 705,
        DB_USER_NOT_FOUND: 706,
        UNKNOWN: 799
    },
    USERS: {
        BASE: 100,
        CREATE_USER: 101,
        GET_USER: 102,
        UPDATE_USER: 103,
        LIST_ORG_USERS: 104,
        PASSWORD_CHANGE: 105,
        PROFILE_CONFIG: 106,
        AI_CONFIG: 107,
        UNKNOWN: 199
    },
    EMAIL: {
        BASE: 2200,
        SEND_INVITATION_EMAIL: 2201,
        UNKNOWN: 2299
    },
    CLASSLINK: {
        BASE: 2400,
        GET_CLASS_LINK_INFO: 2401,
        GET_CLASS_LINK_USER_INFO: 2402,
        UNKNOWN: 2499
    },
    CANVAS: {
        BASE: 1700,
        SYNC_ASSIGNMENT: 1701,
        UNKNOWN: 1799
    },
    GOOGLE_CLASSROOM: {
        BASE: 1600,
        SYNC_ASSIGNMENT: 1601,
        UNKNOWN: 1699
    },
    IMAGE_GALLERY: {
        BASE: 5500,
        LIST_GALLERY_IMAGES: 5501,
        CREATE_GALLERY_IMAGE: 5502,
        DELETE_GALLERY_IMAGE: 5503,
        UNKNOWN: 5599
    },
    LIVE_LOGS: {
        BASE: 5100,
        UPDATE_PAGE_VISIT: 5101,
        UPDATE_FIREBASE_ON_CLOSE: 5102,
        CLEAR_BROADCAST_URL: 5103,
        BROADCAST_URL: 5104,
        BROADCAST_MESSAGE: 5105,
        USE_ACTIVE_CLASS_URL: 5106,
        USE_ACTIVE_CLASS_URL_LISTENER: 5107,
        UNKNOWN: 5199
    },
    PAGE_TRANSLATIONS: {
        BASE: 3000,
        FETCH_PAGE_TRANSLATIONS: 3001,
        FETCH_BOOK_GRAMMAR_CONTENT: 3002,
        FETCH_BOOK_VOCAB_CONTENT: 3003,
        UNKNOWN: 3099
    },
    VOCABULARY: {
        BASE: 1300,
        LIST_VOCABULARY: 1301,
        CREATE_VOCABULARY: 1302,
        UPDATE_VOCABULARY: 1303,
        DELETE_VOCABULARY: 1304,
        GET_VOCABULARY_CONTENT: 1305,
        UPDATE_VOCABULARY_CONTENT: 1306,
        LIST_VOCABULARY_CONTENT: 1307,
        LIST_VOCABULARY_STUDENT: 1308,
        GET_VOCABULARY_PREFERENCE: 1309,
        UPDATE_VOCABULARY_PREFERENCE: 1310,
        GET_VOCABULARY_FEEDBACK_WORD_BANK: 1311,
        GET_VOCABULARY_WORKSHEET_ACTIVITY: 1312,
        GET_VOCABULARY_WORKSHEET_MESSAGE: 1313,
        LIST_VOCABULARY_CONTENT_FEEDBACK_STUDENT: 1314,
        UPDATE_VOCABULARY_MESSAGE: 1315,
        CREATE_VOCABULARY_ACTIVITY: 1316,
        CREATE_VOCABULARY_ACTIVITY_QUIZ: 1317,
        DELETE_VOCABULARY_CONTENT: 1318,
        UNKNOWN: 1399
    },
    QUIZZES: {
        BASE: 1000,
        LIST_QUIZ: 1001,
        CREATE_QUIZ: 1002,
        UPDATE_QUIZ: 1003,
        DELETE_QUIZ: 1004,
        LIST_QUIZ_BOOK_INSTRUCTION: 1005,
        UNKNOWN: 1099
    },
    SUBMISSIONS: {
        BASE: 1100,
        LIST_SUBMISSION: 1101,
        CREATE_SUBMISSION: 1102,
        UPDATE_SUBMISSION: 1103,
        DELETE_SUBMISSION: 1104,
        UNKNOWN: 1199
    },
    WORKSHEET: {
        BASE: 1200,
        LIST_WORKSHEET: 1201,
        CREATE_WORKSHEET: 1202,
        UPDATE_WORKSHEET: 1203,
        DELETE_WORKSHEET: 1204,
        UNKNOWN: 1299
    },
    LESSON_PLAN: {
        BASE: 1400,
        LIST_LESSON: 1401,
        CREATE_LESSON: 1402,
        UPDATE_LESSON: 1403,
        DELETE_LESSON: 1404,
        UNKNOWN: 1499
    },
    SCHOOLOGY: {
        BASE: 1500,
        LIST_SCHOOLOGY: 1501,
        CREATE_SCHOOLOGY: 1502,
        UPDATE_SCHOOLOGY: 1503,
        DELETE_SCHOOLOGY: 1504,
        UNKNOWN: 1599
    },
    STANDARD_EXAMS: {
        BASE: 1800,
        LIST_STANDARD_EXAM: 1801,
        CREATE_STANDARD_EXAM: 1802,
        UPDATE_STANDARD_EXAM: 1803,
        DELETE_STANDARD_EXAM: 1804,
        UNKNOWN: 1899
    },
    SENTENCE_STARTER: {
        BASE: 1900,
        LIST_SENTENCE_STARTER: 1901,
        CREATE_SENTENCE_STARTER: 1902,
        UPDATE_SENTENCE_STARTER: 1903,
        DELETE_SENTENCE_STARTER: 1904,
        UNKNOWN: 1999
    },
    NOTES: {
        BASE: 2000,
        LIST_NOTE: 2001,
        CREATE_NOTE: 2002,
        UPDATE_NOTE: 2003,
        DELETE_NOTE: 2004,
        UNKNOWN: 2099
    },
    KEYSTORE: {
        BASE: 2100,
        LIST_KEYSTORE: 2101,
        CREATE_KEYSTORE: 2102,
        UPDATE_KEYSTORE: 2103,
        DELETE_KEYSTORE: 2104,
        UNKNOWN: 2199
    },
    COGANTES: {
        BASE: 2300,
        LIST_COGANTES: 2301,
        CREATE_COGANTES: 2302,
        UPDATE_COGANTES: 2303,
        DELETE_COGANTES: 2304,
        UNKNOWN: 2399
    },
    BINGO: {
        BASE: 2500,
        LIST_BINGO: 2501,
        CREATE_BINGO: 2502,
        UPDATE_BINGO: 2503,
        DELETE_BINGO: 2504,
        UNKNOWN: 2599
    },
    SUPER_LESSON: {
        BASE: 2600,
        LIST_SUPER_LESSON: 2601,
        CREATE_SUPER_LESSON: 2602,
        UPDATE_SUPER_LESSON: 2603,
        DELETE_SUPER_LESSON: 2604,
        UNKNOWN: 2699
    },
    STORY_AI_CONFIG: {
        BASE: 2700,
        LIST_STORY_AI_CONFIG: 2701,
        CREATE_STORY_AI_CONFIG: 2702,
        UPDATE_STORY_AI_CONFIG: 2703,
        DELETE_STORY_AI_CONFIG: 2704,
        UNKNOWN: 2799
    },
    DIFFERENTIATION_LESSON: {
        BASE: 2800,
        LIST_DIFFERENTIATION_LESSON: 2801,
        CREATE_DIFFERENTIATION_LESSON: 2802,
        UPDATE_DIFFERENTIATION_LESSON: 2803,
        DELETE_DIFFERENTIATION_LESSON: 2804,
        UNKNOWN: 2899
    },
    SCHOOLOGY_AUTH: {
        BASE: 2900,
        LIST_SCHOOLOGY_AUTH: 2901,
        CREATE_SCHOOLOGY_AUTH: 2902,
        UPDATE_SCHOOLOGY_AUTH: 2903,
        DELETE_SCHOOLOGY_AUTH: 2904,
        UNKNOWN: 2999
    },
    ONE_GAME: {
        BASE: 3100,
        LIST_ONE_GAME: 3101,
        CREATE_ONE_GAME: 3102,
        UPDATE_ONE_GAME: 3103,
        DELETE_ONE_GAME: 3104,
        UNKNOWN: 3199
    },
    EXTRA_RESOURCE: {
        BASE: 3200,
        LIST_EXTRA_RESOURCE: 3201,
        CREATE_EXTRA_RESOURCE: 3202,
        UPDATE_EXTRA_RESOURCE: 3203,
        DELETE_EXTRA_RESOURCE: 3204,
        UNKNOWN: 3299
    },
    CLEVER: {
        BASE: 3300,
        LIST_CLEVER: 3301,
        CREATE_CLEVER: 3302,
        UPDATE_CLEVER: 3303,
        DELETE_CLEVER: 3304,
        UNKNOWN: 3399
    },
    WORD_BANK: {
        BASE: 3400,
        LIST_WORD_BANK: 3401,
        CREATE_WORD_BANK: 3402,
        UPDATE_WORD_BANK: 3403,
        DELETE_WORD_BANK: 3404,
        UNKNOWN: 3499
    },
    WIDGETS: {
        BASE: 3500,
        LIST_WIDGET: 3501,
        CREATE_WIDGET: 3502,
        UPDATE_WIDGET: 3503,
        DELETE_WIDGET: 3504,
        UNKNOWN: 3599
    },
    WHATS_NEW: {
        BASE: 3600,
        LIST_WHATS_NEW: 3601,
        CREATE_WHATS_NEW: 3602,
        UPDATE_WHATS_NEW: 3603,
        DELETE_WHATS_NEW: 3604,
        UNKNOWN: 3699
    },
    WELCOME_VIDEO: {
        BASE: 3700,
        LIST_WELCOME_VIDEO: 3701,
        CREATE_WELCOME_VIDEO: 3702,
        UPDATE_WELCOME_VIDEO: 3703,
        DELETE_WELCOME_VIDEO: 3704,
        UNKNOWN: 3799
    },
    USER_PREFERENCE: {
        BASE: 3800,
        LIST_USER_PREFERENCE: 3801,
        CREATE_USER_PREFERENCE: 3802,
        UPDATE_USER_PREFERENCE: 3803,
        DELETE_USER_PREFERENCE: 3804,
        UNKNOWN: 3899
    },
    USER_CLASSES: {
        BASE: 3900,
        LIST_USER_CLASS: 3901,
        CREATE_USER_CLASS: 3902,
        UPDATE_USER_CLASS: 3903,
        DELETE_USER_CLASS: 3904,
        UNKNOWN: 3999
    },
    USER_BOOKS: {
        BASE: 4000,
        LIST_USER_BOOK: 4001,
        CREATE_USER_BOOK: 4002,
        UPDATE_USER_BOOK: 4003,
        DELETE_USER_BOOK: 4004,
        UNKNOWN: 4099
    },
    TIPS: {
        BASE: 4100,
        LIST_TIPS: 4101,
        CREATE_TIPS: 4102,
        UPDATE_TIPS: 4103,
        DELETE_TIPS: 4104,
        UNKNOWN: 4199
    },
    STUDENT_GROUP: {
        BASE: 4200,
        LIST_STUDENT_GROUP: 4201,
        CREATE_STUDENT_GROUP: 4202,
        UPDATE_STUDENT_GROUP: 4203,
        DELETE_STUDENT_GROUP: 4204,
        UNKNOWN: 4299
    },
    STORY: {
        BASE: 4300,
        LIST_STORY: 4301,
        CREATE_STORY: 4302,
        UPDATE_STORY: 4303,
        DELETE_STORY: 4304,
        UNKNOWN: 4399
    },
    SERVER_TIME: {
        BASE: 4400,
        GET_SERVER_TIME: 4401,
        UNKNOWN: 4499
    },
    SELECTED_USER: {
        BASE: 4500,
        GET_SELECTED_USER: 4501,
        SET_SELECTED_USER: 4502,
        UNKNOWN: 4599
    },
    RUBRIC: {
        BASE: 4600,
        LIST_RUBRIC: 4601,
        CREATE_RUBRIC: 4602,
        UPDATE_RUBRIC: 4603,
        DELETE_RUBRIC: 4604,
        UNKNOWN: 4699
    },
    RESOURCES: {
        BASE: 4700,
        LIST_RESOURCE: 4701,
        CREATE_RESOURCE: 4702,
        UPDATE_RESOURCE: 4703,
        DELETE_RESOURCE: 4704,
        UNKNOWN: 4799
    },
    PLACEMENT_EXAM: {
        BASE: 4800,
        LIST_PLACEMENT_EXAM: 4801,
        CREATE_PLACEMENT_EXAM: 4802,
        UPDATE_PLACEMENT_EXAM: 4803,
        DELETE_PLACEMENT_EXAM: 4804,
        UNKNOWN: 4899
    },
    PAST_SUBMISSION: {
        BASE: 4900,
        LIST_PAST_SUBMISSION: 4901,
        CREATE_PAST_SUBMISSION: 4902,
        UPDATE_PAST_SUBMISSION: 4903,
        DELETE_PAST_SUBMISSION: 4904,
        UNKNOWN: 4999
    },
    NOTIFICATION: {
        BASE: 5000,
        LIST_NOTIFICATION: 5001,
        CREATE_NOTIFICATION: 5002,
        UPDATE_NOTIFICATION: 5003,
        DELETE_NOTIFICATION: 5004,
        UNKNOWN: 5099
    },
    LICENCES: {
        BASE: 5200,
        LIST_LICENCE: 5201,
        CREATE_LICENCE: 5202,
        UPDATE_LICENCE: 5203,
        DELETE_LICENCE: 5204,
        UNKNOWN: 5299
    },
    INTERACTIONS: {
        BASE: 5300,
        LIST_INTERACTION: 5301,
        CREATE_INTERACTION: 5302,
        UPDATE_INTERACTION: 5303,
        DELETE_INTERACTION: 5304,
        UNKNOWN: 5399
    },
    INSTRUCTIONS: {
        BASE: 5400,
        LIST_INSTRUCTION: 5401,
        CREATE_INSTRUCTION: 5402,
        UPDATE_INSTRUCTION: 5403,
        DELETE_INSTRUCTION: 5404,
        UNKNOWN: 5499
    },
    HOW_TO_VIDEOS: {
        BASE: 5800,
        LIST_HOW_TO_VIDEO: 5801,
        CREATE_HOW_TO_VIDEO: 5802,
        UPDATE_HOW_TO_VIDEO: 5803,
        DELETE_HOW_TO_VIDEO: 5804,
        UNKNOWN: 5899
    },
    GAME_SESSION: {
        BASE: 5900,
        LIST_GAME_SESSION: 5901,
        CREATE_GAME_SESSION: 5902,
        UPDATE_GAME_SESSION: 5903,
        DELETE_GAME_SESSION: 5904,
        UNKNOWN: 5999
    },
    FEEDBACK: {
        BASE: 6000,
        LIST_FEEDBACK: 6001,
        CREATE_FEEDBACK: 6002,
        UPDATE_FEEDBACK: 6003,
        DELETE_FEEDBACK: 6004,
        UNKNOWN: 6099
    },
    EBOOK_HIGHLIGHTER: {
        BASE: 6100,
        LIST_EBOOK_HIGHLIGHTER: 6101,
        CREATE_EBOOK_HIGHLIGHTER: 6102,
        UPDATE_EBOOK_HIGHLIGHTER: 6103,
        DELETE_EBOOK_HIGHLIGHTER: 6104,
        UNKNOWN: 6199
    },
    EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER: {
        BASE: 6200,
        LIST_EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER: 6201,
        CREATE_EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER: 6202,
        UPDATE_EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER: 6203,
        DELETE_EBOOK_NON_NATIVE_IMAGE_HIGHLIGHTER: 6204,
        UNKNOWN: 6299
    },
    DEBATE: {
        BASE: 6300,
        LIST_DEBATE: 6301,
        CREATE_DEBATE: 6302,
        UPDATE_DEBATE: 6303,
        DELETE_DEBATE: 6304,
        UNKNOWN: 6399
    },
    CLASS_QUIZZES: {
        BASE: 6400,
        LIST_CLASS_QUIZ: 6401,
        CREATE_CLASS_QUIZ: 6402,
        UPDATE_CLASS_QUIZ: 6403,
        DELETE_CLASS_QUIZ: 6404,
        UNKNOWN: 6499
    },
    CLASS_ACTIVITIES: {
        BASE: 6500,
        LIST_CLASS_ACTIVITY: 6501,
        CREATE_CLASS_ACTIVITY: 6502,
        UPDATE_CLASS_ACTIVITY: 6503,
        DELETE_CLASS_ACTIVITY: 6504,
        UNKNOWN: 6599
    },
    BOOKS_UNITS: {
        BASE: 6600,
        LIST_BOOKS_UNIT: 6601,
        CREATE_BOOKS_UNIT: 6602,
        UPDATE_BOOKS_UNIT: 6603,
        DELETE_BOOKS_UNIT: 6604,
        UNKNOWN: 6699
    },
    BOOKMARK: {
        BASE: 6700,
        LIST_BOOKMARK: 6701,
        CREATE_BOOKMARK: 6702,
        UPDATE_BOOKMARK: 6703,
        DELETE_BOOKMARK: 6704,
        UNKNOWN: 6799
    },
    AP_EXAMS: {
        BASE: 6800,
        LIST_AP_EXAM: 6801,
        CREATE_AP_EXAM: 6802,
        UPDATE_AP_EXAM: 6803,
        DELETE_AP_EXAM: 6804,
        UNKNOWN: 6899
    },
    FAVOURITE_VIDEO: {
        BASE: 7100,
        LIST_FAVOURITE_VIDEO: 7101,
        CREATE_FAVOURITE_VIDEO: 7102,
        UPDATE_FAVOURITE_VIDEO: 7103,
        DELETE_FAVOURITE_VIDEO: 7104,
        UNKNOWN: 7199
    },
    ONE_WAY_TEACHER_VIDEO: {
        BASE: 7200,
        LIST_ONE_WAY_TEACHER_VIDEO: 7201,
        CREATE_ONE_WAY_TEACHER_VIDEO: 7202,
        UPDATE_ONE_WAY_TEACHER_VIDEO: 7203,
        DELETE_ONE_WAY_TEACHER_VIDEO: 7204,
        UNKNOWN: 7299
    },
    ONE_GAME_VIDEO: {
        BASE: 7300,
        LIST_ONE_GAME_VIDEO: 7301,
        CREATE_ONE_GAME_VIDEO: 7302,
        UPDATE_ONE_GAME_VIDEO: 7303,
        DELETE_ONE_GAME_VIDEO: 7304,
        UNKNOWN: 7399
    },
    ONE_GAME_GALLERY: {
        BASE: 7400,
        LIST_ONE_GAME_GALLERY: 7401,
        CREATE_ONE_GAME_GALLERY: 7402,
        UPDATE_ONE_GAME_GALLERY: 7403,
        DELETE_ONE_GAME_GALLERY: 7404,
        UNKNOWN: 7499
    },
    ONE_GAME_CATEGORY: {
        BASE: 7500,
        LIST_ONE_GAME_CATEGORY: 7501,
        CREATE_ONE_GAME_CATEGORY: 7502,
        UPDATE_ONE_GAME_CATEGORY: 7503,
        DELETE_ONE_GAME_CATEGORY: 7504,
        UNKNOWN: 7599
    },
    SLIDES: {
        BASE: 7600,
        LIST_SLIDE: 7601,
        CREATE_SLIDE: 7602,
        UPDATE_SLIDE: 7603,
        DELETE_SLIDE: 7604,
        UNKNOWN: 7699
    },
    AUDIO: {
        BASE: 7700,
        RESUME_AUDIO: 7701,
        UNKNOWN: 7799
    },
    VIDEO: {
        BASE: 7800,
        RESUME_VIDEO: 7801,
        UNKNOWN: 7899
    },
    IMAGE: {
        BASE: 7900,
        RESUME_IMAGE: 7901,
        UNKNOWN: 7999
    },
};

export const getErrorCode = (module, operation) => {
    const moduleCodes = ERROR_CODE_RANGES[module];
    if (!moduleCodes) {
        return '000';
    }
    
    const code = moduleCodes[operation];
    if (!code) {
        return moduleCodes.BASE;
    }
    
    return code.toString();
};
